import JoinUsSignup from './JoinUsSignup.page';

export default JoinUsSignup;